import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {HTTP_STATUS_OK} from '../../../Constants'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {severityNotification} from '../../notification/NotificationConstant'
import {showNotification} from '../../notification/NotificationService'
import {
    createOrUpdateGeneralPractitioner,
    deleteGeneralPractitioner,
    getDetailGeneralPractitioner,
    getListGeneralPractitioners,
    getPageGeneralPractitioners,
} from '../GeneralPractitionerEndPoint'

export const usePageGeneralPractitioners = (
    requestorId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
    enabled = true,
) => {
    const {generalPractitionerKeys} = QueryKeyManager(
        QueryKeyTypes.generalPractitioner,
        requestorId,
    )

    return useQuery({
        queryKey: generalPractitionerKeys.page({
            pageNumber,
            pageRows,
            sortField,
            sortOrder,
            filterRequest,
        }),
        queryFn: () =>
            getPageGeneralPractitioners(
                requestorId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
                filterRequest,
            ),
        enabled: !!requestorId && !!enabled,
    })
}

export const useListGeneralPractitioners = (
    requestorId,
    simple,
    filterRequest,
    enabled = true,
) => {
    const {generalPractitionerKeys} = QueryKeyManager(
        QueryKeyTypes.generalPractitioner,
        requestorId,
    )

    return useQuery({
        queryKey: generalPractitionerKeys.list({
            simple,
            filterRequest,
        }),
        queryFn: () =>
            getListGeneralPractitioners(requestorId, simple, filterRequest),
        enabled: !!requestorId && !!enabled,
    })
}

export const useGeneralPractitionerCRUD = (type, requestorId) => {
    const {generalPractitionerKeys} = QueryKeyManager(
        QueryKeyTypes.generalPractitioner,
        requestorId,
    )

    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data =>
            type === QueryCRUDTypes.create || type === QueryCRUDTypes.update
                ? createOrUpdateGeneralPractitioner(requestorId, data)
                : type === QueryCRUDTypes.delete
                ? deleteGeneralPractitioner(requestorId, data?.id)
                : data,
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data === HTTP_STATUS_OK || data?.id) {
                if (
                    type === QueryCRUDTypes.create ||
                    type === QueryCRUDTypes.update
                ) {
                    showNotification(
                        severityNotification.success,
                        'General Practitioner Update Successfully !!',
                    )
                } else if (type === QueryCRUDTypes.delete) {
                    showNotification(
                        severityNotification.success,
                        'Deletion performed successfully!!',
                    )
                }
            }
        },
    })
}

export const useDetailGeneralPractitioner = (
    requestorId,
    id,
    enabled = true,
) => {
    const {generalPractitionerKeys} = QueryKeyManager(
        QueryKeyTypes.generalPractitioner,
        requestorId,
    )
    return useQuery({
        queryKey: generalPractitionerKeys.detail({id}),
        queryFn: () => getDetailGeneralPractitioner(requestorId, id),
        enabled: !!requestorId && !!id && !!enabled,
    })
}
